import { Box, Icon, InlineStack, Text } from '@shopify/polaris';
import { CaretDownIcon } from '@shopify/polaris-icons';
import { cls } from '~/utils';

interface OrderCellBaseProps {
  value: string;
  justifyContent: React.CSSProperties['justifyContent'];
  isPrevious?: boolean;
  isTotalRow?: boolean;
  interactive?: {
    onClick: () => void;
    hovering: boolean;
    onHoverChange: (hovering: boolean) => void;
  };
}

export const OrderCellBase: React.FC<OrderCellBaseProps> = ({
  value,
  justifyContent,
  isPrevious,
  isTotalRow,
  interactive,
}) => {
  const { onClick, hovering, onHoverChange } = interactive ?? {};
  const ableInteractive = !!interactive;

  return (
    <div
      className={cls(
        'GReportTable__CellContent--clickable flex items-center pl-3 w-full h-7 px-[8px]',
        { 'cursor-pointer hover:bg-surface-hover': ableInteractive },
        { 'GReportTable__CellContent--noClick': !ableInteractive },
      )}
      style={{ justifyContent }}
      onClick={onClick ?? undefined}
      onMouseEnter={ableInteractive ? () => onHoverChange?.(true) : undefined}
      onMouseLeave={ableInteractive ? () => onHoverChange?.(false) : undefined}
    >
      <InlineStack blockAlign="center" wrap={false}>
        <Text
          as="span"
          variant="bodyMd"
          fontWeight={isTotalRow ? 'semibold' : 'regular'}
          tone={isPrevious ? 'subdued' : 'inherit'}
        >
          {value}
        </Text>

        <Box opacity={hovering && ableInteractive ? '1' : '0'}>
          <Icon source={CaretDownIcon} />
        </Box>
      </InlineStack>
    </div>
  );
};
